<template>
  <v-flex class="ml-3 mobile-filter-sidebar-container">
    <v-card color="white px-2 py-2" class="filter_sidebar" style="width: 100%">
      <v-layout row wrap>
        <v-flex class="flex-list" xs6>
          <v-menu lazy :close-on-content-click="false" v-model="datepickermenufrom" transition="scale-transition" offset-y full-width
              :nudge-left="40" max-width="290px">
              <v-text-field slot="activator" required placeholder="From" v-model="fromdate" readonly style="padding-top: 0px;"/>
              <v-date-picker v-model="fromdate" no-title scrollable>
                <template>
                  <v-card-actions>
                    <v-btn flat primary @click="datepickermenufrom = false">OK</v-btn>
                  </v-card-actions>
                </template>
              </v-date-picker>
            </v-menu>
        </v-flex>
        <v-flex class="flex-list" xs6>
            <v-menu lazy :close-on-content-click="false" v-model="datepickermenuto" transition="scale-transition" offset-y full-width
              :nudge-left="40" max-width="290px">
              <v-text-field slot="activator" required placeholder="To" v-model="todate" readonly style="padding-top: 0px;"/>
              <v-date-picker v-model="todate" no-title scrollable>
                <template>
                  <v-card-actions>
                    <v-btn flat primary @click="datepickermenuto = false">OK</v-btn>
                  </v-card-actions>
                </template>
              </v-date-picker>
            </v-menu>
        </v-flex>
        <v-flex class="flex-list" xs6>
          <multiple-filter :single="true" :all="true" :list="contents" id='contenttype' @apply='applyFilter' label="Content Type" :input="''" />
        </v-flex>
        <v-flex class="flex-list" xs6>
          <multiple-filter :single="true" :all="true" :list="categories" id='category' @apply='applyFilter' label="Category" :input="''" />
        </v-flex>
        <v-flex>
          <v-btn class="date_btn mt-2" style="width: 100%;" primary @click="save()">Filter</v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import MultipleFilter from '@/components/filter/multipleFilter.vue'
export default {
  props: ['filterPost', 'featuredResources', 'contentType', 'category'],
  components: {
    MultipleFilter
  },
  data () {
    return {
      input: null,
      datepickermenu: false,
      datepickermenuto: false,
      datepickermenufrom: false,
      datefilter: null,
      fromdate: null,
      todate: null,
      dialog: false,
      item: null,
      counter: 9,
      width: '',
      search: '',
      filterType: '',
      filterValue: '',
      items: [],
      count: 0,
      countlength: 0
    }
  },
  methods: {
    applyFilter ({ id, filter }) {
      if (filter.text.indexOf('All') >= 0) {
        return this.featuredResources(9)
      }
      return this.filterPost(id, filter.text)
    },
    save() {
      let self = this;
      self.items = [];
      self.resources = [];
      if (this.fromdate && this.todate) {
        this.$firebase
          .database()
          .ref("resources")
          .orderByChild("revisiondate")
          .startAt(Date.parse(this.fromdate))
          .endAt(Date.parse(this.todate))
          .on("value", snap => {
            self.items = [];
            self.resources = [];
            snap.forEach(childSnapshot => {
              const childData = childSnapshot.val();
              self.getUserInfo(childData.uid, self.count).then(result => {
                self.items.push(childData);
              });
            });
            self.counter = 9
            self.resources = self.items;
          });
      }
    },
    getUserInfo(uid, index) {
      return this.$firebase
        .database()
        .ref("users/" + uid)
        .once("value");
    },
  },
  computed: {
    contents () {
      let list = this.contentType
      if (!list.includes('All Content Types')) {
        list.push('All Content Types')
      }
      list = list
        .filter(type => type)
        .map(type => {
          return {
            text: type,
            value: {
              text: type, 
              value: type 
            } 
          }
        })
      return list
    },
    categories () {
      let list = this.category
      if (!list.includes('All categories')) {
        list.push('All categories')
      }
      list = list
        .filter(type => type)
        .map(type => {
          return {
            text: type,
            value: {
              text: type, 
              value: type 
            } 
          }
        })
      return list
    }
  }
}
</script>

<style>
  .flex-list {
    padding: 4px;
  }
  .flex-list .input-group__details {
    min-height: 0px;
  }
  .flex-list .menu {
    margin-left: 0px;
  }
</style>



// WEBPACK FOOTER //
// ResourcesFilter.vue?09e54eee